module.exports = string => {
  return string.toLowerCase().trim().replace(/\s+/g, '-')
}
